import * as React from 'react';
import { useTranslation } from 'react-i18next';

import styled from '@emotion/styled';
import { IconButton, tokens } from '@hotjar/hotsauce';

interface Props {
  onSearchClick: () => void;
}

const Container = styled.span`
  color: ${tokens.color.text_light};
  ${tokens.text('subtitle3')};
  display: flex;
  padding: ${tokens.spacer.x2} ${tokens.spacer.x4} 0 ${tokens.spacer.x4};
  align-items: center;
  justify-content: space-between;
`;

export const Title = ({ onSearchClick }: Props): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Container>
      {t('common:recordings.segment-sidebar.segments-title')}
      <IconButton
        data-testid="search-segment-icon"
        tooltipText={t('common:recordings.segment-sidebar.search-segments') as string}
        description={t('common:recordings.segment-sidebar.search-segments')}
        onClick={onSearchClick}
        icon="search"
        size="s"
        kind="ghost"
      />
    </Container>
  );
};
